import React from "react";
var GenericStars = function (props) {
    var star = [];
    var prev = 0;
    for (var i = 1; i <= 5; i++) {
        props.ratingnumber >= i && props.ratingnumber != null
            ? star.push(React.createElement("label", { className: "txt_yellow" },
                React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { d: "M8.74309 0L10.6063 5.7343H16.6357L11.7578 9.27829L13.621 15.0126L8.74309 11.4686L3.8652 15.0126L5.72839 9.27829L0.850506 5.7343H6.8799L8.74309 0Z", fill: "none" }))))
            : props.ratingnumber < i &&
                props.ratingnumber > prev &&
                props.ratingnumber != null
                ? star.push(React.createElement("label", { className: "halfstar" },
                    React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("linearGradient", { id: "gradient" },
                            React.createElement("stop", { offset: "50%", "stop-color": "#ffb800" }),
                            React.createElement("stop", { offset: "50%", "stop-color": "#e2e2e2" })),
                        React.createElement("rect", { width: "100", height: "50" }),
                        React.createElement("path", { d: "M8.74309 0L10.6063 5.7343H16.6357L11.7578 9.27829L13.621 15.0126L8.74309 11.4686L3.8652 15.0126L5.72839 9.27829L0.850506 5.7343H6.8799L8.74309 0Z", fill: "none" }))))
                : star.push(React.createElement("label", { className: "txt-footer-light" },
                    React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M8.74309 0L10.6063 5.7343H16.6357L11.7578 9.27829L13.621 15.0126L8.74309 11.4686L3.8652 15.0126L5.72839 9.27829L0.850506 5.7343H6.8799L8.74309 0Z", fill: "none" }))));
        prev = i;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "gen-stars-rating-block" },
            props.isratingnumberpresent && (React.createElement("span", { className: "DMSans_16_500 txt_blackOne1" }, props.ratingnumber >= 0
                ? props.ratingnumber <= 5
                    ? props.ratingnumber
                    : "5"
                : "")),
            props.isstarspresent && (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "stars", onClick: props.onClick }, star))))));
};
export default GenericStars;
